// client/src/pages/ForgotPasswordPage.js
// Public "forgot my password" request screen. Posts a username or email and always
// shows the same confirmation (the server never reveals whether an account exists).
import React from 'react';
import { Link } from 'react-router-dom';

const ForgotPasswordPage = () => {
    const [identifier, setIdentifier] = React.useState('');
    const [busy, setBusy] = React.useState(false);
    const [sent, setSent] = React.useState(false);
    const [error, setError] = React.useState('');

    const submit = async (e) => {
        e.preventDefault();
        setError('');
        setBusy(true);
        try {
            const resp = await fetch('/api/auth/forgot-password', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ identifier }),
            });
            const data = await resp.json();
            if (!resp.ok) throw new Error(data.message || 'Request failed.');
            setSent(true);
        } catch (err) {
            setError(err.message);
        } finally {
            setBusy(false);
        }
    };

    const inputCls = 'block w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-slate-500 focus:border-slate-500 sm:text-sm';

    return (
        <div className="flex items-center justify-center min-h-screen bg-slate-100">
            <div className="w-full max-w-md p-8 space-y-6 bg-white rounded-xl shadow-lg">
                <div className="text-center">
                    <h2 className="text-2xl font-bold text-gray-900">Reset your password</h2>
                    <p className="mt-2 text-sm text-gray-600">
                        Enter your username or email and we'll send a reset link to the address on file.
                    </p>
                </div>

                {sent ? (
                    <div className="space-y-4">
                        <p className="text-green-700 bg-green-50 border border-green-200 rounded p-3 text-sm">
                            If an account matches, a reset link has been emailed. The link expires in 1 hour.
                        </p>
                        <Link to="/portal" className="block text-center text-sm text-indigo-600 hover:underline">
                            Back to sign in
                        </Link>
                    </div>
                ) : (
                    <form className="space-y-4" onSubmit={submit}>
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">Username or email</label>
                            <input type="text" required autoFocus className={inputCls}
                                value={identifier} onChange={(e) => setIdentifier(e.target.value)} />
                        </div>
                        {error && <p className="text-sm text-red-600">{error}</p>}
                        <button type="submit" disabled={busy}
                            className="w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-slate-800 hover:bg-slate-900 disabled:bg-indigo-400">
                            {busy ? 'Sending…' : 'Send reset link'}
                        </button>
                        <Link to="/portal" className="block text-center text-sm text-indigo-600 hover:underline">
                            Back to sign in
                        </Link>
                    </form>
                )}
            </div>
        </div>
    );
};

export default ForgotPasswordPage;
